

// js-shop-category-silder//
var swiper = new Swiper("[js-shop-category-silder]", {
    slidesPerView: 4,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      breakpoints: {
        0: {
          slidesPerView: "auto",
          spaceBetween: 10,
        },
        414: {
          slidesPerView: "auto",
          spaceBetween: 10,
        },
        767: {
          slidesPerView: "auto",
          spaceBetween: 10,
        },
        990: {
          slidesPerView: "auto",
          spaceBetween: 10,
        },
        1124: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        1359: {
          slidesPerView: 7,
          spaceBetween: 10,
        },
        1440: {
          slidesPerView: 7,
          spaceBetween: 10,
        }
      },
  });
var swiper = new Swiper("[js-best-deal-silder]", {
    slidesPerView: 6,
    spaceBetween: 30,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 14,
        },
        414: {
          slidesPerView: 2.3,
          spaceBetween: 14,
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
        1279: {
          slidesPerView: 5,
          spaceBetween: 32,
        },
        1440: {
          slidesPerView: 6,
          spaceBetween: 32,
        }
      },
  });